import {Api} from '../Common/rest-api/api-exports';

export const getStatistics = id => {
    return Api.Companies.statistics(id).then(res => res.body).catch(error => error);
};


// WEBPACK FOOTER //
// ./src/customModules/Statistics/epics-statistics.js